














/* Created- 20 - May - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ContentStreamService, IContentStreamService } from "../../BusinessServices/contentstream";
import { ParticaEvent, getActionName, eParticaAction } from "../../Models/ParticaEvent";
import { StreamStatsDTO } from "../../Generated/ParticaAPI";
import ContentStreamStats from "@/Ui-Components/ContentStream/ContentStreamStats.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaAdminBase from "../Base/ParticaAdminBase.vue";
import ParticaCardXl from "@/Ui-Components/Common/Container/ParticaCardMax.vue";
import { ButtonType, ButtonStatus, ButtonConfig } from "../../Models/Buttons";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";

@Component(
	{
		name: "AdminStreams",
		components: {
			ContentStreamStats,
			ParticaView,
			ParticaCardXl,
			ButtonList
		}
	})
export default class AdminStreams extends ParticaAdminBase {
	private service: IContentStreamService;
	private data: StreamStatsDTO[] = [];
	private csbuttons: ButtonConfig[] = [
		{
			label: "Advanced",
			action: eParticaAction.CONTENT_STREAM_ADVANCED,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled

		} as ButtonConfig
	];

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.CONTENT_STREAM_SELECT_STREAM: {
					this.navigate("contentstreamhome", { id: event.item.streamId });
					break;
				}
				case eParticaAction.CONTENT_STREAM_ADVANCED: {
					this.navigate("contentstreamadvanced", {});
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}



	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "All Streams";
		this.service = this.particaServices.getContentStreamService();
		this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			this.data = await this.service.GetAllContentStreams();
			await this.getAdminNav(0);
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
